module.exports = __webpack_public_path__ + "img/rule.9fec34b4.png";